import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import styled from "styled-components";

import Footer from '../components/footer'
import arrow from "./arrow.svg";
import bg from "./bg.png";

class Journals extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const journals = get(this, 'props.data.allMarkdownRemark.edges')

    return (
    <div>
      <Helmet title={get(this, 'props.data.site.siteMetadata.title')}/>
    <div className="root-width rw-pad">
      <div style={{display: "flex", marginTop: "1.5em"}}>
        <div className="journal-side" style={{display: "none"}}>
          <div className="journal-sidebar">Sidebar</div>
        </div>
        <div className="journal-main">
        <h1>Journal</h1>
      <div className="journal-holder">{
            (journals.filter(d => d.type == "journal").length > 0)?
            journals.filter(d => d.type == "journal").map(journal => {
              if (journal.node.path !== '/404/') {
                const title = get(journal, 'node.frontmatter.title') || journal.node.path
                const thumbImage = journal.node.frontmatter.thumb.childImageSharp.resize.src;
                const color = journal.node.frontmatter.color;
                const tags = journal.node.frontmatter.tags;
                const active = journal.node.frontmatter.active;
                const type = journal.node.frontmatter.type;
                  return (
                    <Link to={journal.node.frontmatter.path} key={journal.node.frontmatter.path}>{title}</Link>
                  )
              }
            }):
            <div className="no-data">There are no posts available. Please check back later.</div>
          }

        </div>
      </div>
        </div>
      </div>
      <Footer />
    </div>
  )
  }
}

Journals.propTypes = {
  route: React.PropTypes.object
}

export default Journals


export const JournalQuery = graphql `
  query JournalQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          frontmatter {
            path
            tags
            # date(formatString: "DD MMMM, YYYY")
            active
          }
          frontmatter {
            title
            color
            type
            thumb {
              childImageSharp {
                resize(width: 800) {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/journal.js